import React from 'react';

import CustomSegmentsList from '../components/CustomSegments/CustomSegmentsList';

function CustomSegmentsListPage() {
  return (
    <CustomSegmentsList />
  );
}

export default CustomSegmentsListPage;
